import { z } from 'zod';

import { buildQueryString } from '../../utils/querystring';
import { makeEndpoint, stringBooleanSchema } from '../common';

const responseSchema = z.object({
  message: z.string(),
});

const syncBrandsMetricsManualSchema = z.object({
  brandIds: z.string().array().optional(),
  startDatetime: z.string().datetime().optional(),
  endDatetime: z.string().datetime().optional(),
});

const syncBrandsInfoManualSchema = z.object({
  brandIds: z.string().array().optional(),
  includeInactiveBrands: z.boolean().optional(),
});

const validateIntegrationQuerySchema = z.object({
  includeErrors: stringBooleanSchema.optional(),
});

const validateIntegrationResponseSchema = z.any();

export const SyncBrandsMetricsDailyEndpoint = makeEndpoint({
  method: 'POST',
  url: () => `planhat/sync/daily`,
  responseSchema,
  requestSchema: z.void(),
});

export const SyncBrandsMetricsManualEndpoint = makeEndpoint({
  method: 'POST',
  url: () => `planhat/sync/manual`,
  responseSchema,
  requestSchema: syncBrandsMetricsManualSchema,
});

export const SyncBrandsInfoManualEndpoint = makeEndpoint({
  method: 'POST',
  url: () => `planhat/sync/brands-info`,
  responseSchema,
  requestSchema: syncBrandsInfoManualSchema,
});

export const ValidateIntegrationEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ query }: { query: z.input<typeof validateIntegrationQuerySchema>; brandId: string }) =>
    `planhat/validate?${buildQueryString(query)}`,

  responseSchema: validateIntegrationResponseSchema,
  requestSchema: z.void(),
  querySchema: validateIntegrationQuerySchema,
});
